{
	"asset": {
		"generator": "Khronos glTF Blender I/O v4.1.62",
		"version": "2.0"
	},
	"scene": 0,
	"scenes": [
		{
			"name": "Scene",
			"nodes": [0]
		}
	],
	"nodes": [
		{
			"mesh": 0,
			"name": "Cylinder",
			"rotation": [0, 0, -0.7071068286895752, 0.7071068286895752],
			"scale": [0.5326594710350037, 1.3363600969314575, 0.5298216342926025],
			"translation": [0, 0.9477288722991943, 0]
		}
	],
	"materials": [
		{
			"doubleSided": true,
			"name": "Material.001",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.14345639944076538, 0.0451614186167717, 0.006090801674872637, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		},
		{
			"doubleSided": true,
			"name": "Material.002",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.37705934047698975, 0.17712287604808807, 0.029553666710853577, 1],
				"metallicFactor": 0
			}
		},
		{
			"doubleSided": true,
			"name": "Material",
			"pbrMetallicRoughness": {
				"baseColorFactor": [0.2765146791934967, 0.08278857171535492, 0.006658048368990421, 1],
				"metallicFactor": 0,
				"roughnessFactor": 0.5
			}
		}
	],
	"meshes": [
		{
			"name": "Cylinder",
			"primitives": [
				{
					"attributes": {
						"POSITION": 0,
						"NORMAL": 1,
						"TEXCOORD_0": 2
					},
					"indices": 3,
					"material": 0
				},
				{
					"attributes": {
						"POSITION": 4,
						"NORMAL": 5,
						"TEXCOORD_0": 6
					},
					"indices": 7,
					"material": 1
				},
				{
					"attributes": {
						"POSITION": 8,
						"NORMAL": 9,
						"TEXCOORD_0": 10
					},
					"indices": 11,
					"material": 2
				}
			]
		}
	],
	"accessors": [
		{
			"bufferView": 0,
			"componentType": 5126,
			"count": 354,
			"max": [1.126556158065796, 1.0533137321472168, 1.1054569482803345],
			"min": [-1.1010702848434448, -1.0534154176712036, -1.1002435684204102],
			"type": "VEC3"
		},
		{
			"bufferView": 1,
			"componentType": 5126,
			"count": 354,
			"type": "VEC3"
		},
		{
			"bufferView": 2,
			"componentType": 5126,
			"count": 354,
			"type": "VEC2"
		},
		{
			"bufferView": 3,
			"componentType": 5123,
			"count": 780,
			"type": "SCALAR"
		},
		{
			"bufferView": 4,
			"componentType": 5126,
			"count": 338,
			"max": [1, 1.0533137321472168, 1],
			"min": [-1.0249497890472412, -1.0534154176712036, -1],
			"type": "VEC3"
		},
		{
			"bufferView": 5,
			"componentType": 5126,
			"count": 338,
			"type": "VEC3"
		},
		{
			"bufferView": 6,
			"componentType": 5126,
			"count": 338,
			"type": "VEC2"
		},
		{
			"bufferView": 7,
			"componentType": 5123,
			"count": 600,
			"type": "SCALAR"
		},
		{
			"bufferView": 8,
			"componentType": 5126,
			"count": 141,
			"max": [1.126556158065796, 1.0533137321472168, 1.1054569482803345],
			"min": [-1.1010702848434448, -1.0534154176712036, -1.1002435684204102],
			"type": "VEC3"
		},
		{
			"bufferView": 9,
			"componentType": 5126,
			"count": 141,
			"type": "VEC3"
		},
		{
			"bufferView": 10,
			"componentType": 5126,
			"count": 141,
			"type": "VEC2"
		},
		{
			"bufferView": 11,
			"componentType": 5123,
			"count": 384,
			"type": "SCALAR"
		}
	],
	"bufferViews": [
		{
			"buffer": 0,
			"byteLength": 4248,
			"byteOffset": 0,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 4248,
			"byteOffset": 4248,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2832,
			"byteOffset": 8496,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1560,
			"byteOffset": 11328,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 4056,
			"byteOffset": 12888,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 4056,
			"byteOffset": 16944,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 2704,
			"byteOffset": 21000,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1200,
			"byteOffset": 23704,
			"target": 34963
		},
		{
			"buffer": 0,
			"byteLength": 1692,
			"byteOffset": 24904,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1692,
			"byteOffset": 26596,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 1128,
			"byteOffset": 28288,
			"target": 34962
		},
		{
			"buffer": 0,
			"byteLength": 768,
			"byteOffset": 29416,
			"target": 34963
		}
	],
	"buffers": [
		{
			"byteLength": 30184,
			"uri": "wood.bin"
		}
	]
}
